<template>
  <div :id="data.id" class="promocodes-block offers">
    <PromocodesDefault
      v-if="promoData"
      class="l-container"
      :data="promoData"
      :new-tab="true"
    />
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import type { PromoPage } from '~/interfaces/api';
const PromocodesDefault = defineAsyncComponent(
  () =>
    import('~/components/constructor-components/promocodes/default/Default.vue')
);

const props = defineProps({
  data: {
    type: Object as () => PromoPage,
  },
});

const promoData = computed(() => {
  if (!props.data) return null;
  return {
    ...props.data,
    goto: {
      page_type: 'promocodes',
      title: 'Все промокоды',
      url: '/promokody/',
    },
  };
});
</script>

<style lang="scss" scoped>
.promocodes {
  margin-bottom: 0 !important;
}
.promocodes-block {
  padding-top: 7px;
}
</style>
